<template>
	<div class="jdb_notice">
		<div class="jdb_notice_wrap">
			<div class="close_btn" @click="onClose"></div>
			<div class="jdb_notice_icon"></div>
			<div class="jdb_notice_title">开启节点小宝</div>
			<div class="jdb_notice_select_wrap">
				<div class="jdb_notice_select">可启用全速下载模式</div>
			</div>
			<div class="jdb_notice_select_wrap">
				<div class="jdb_notice_select">可同时下载多个任务</div>
			</div>
			<div class="open_btn" @click="openJdb">立即开启</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    methods: {
        ...mapActions([
			"setDevJdbStatus"
		]),
        onClose: function() {
            let _that = this;
            _that.$store.state.isShowJdbNotice = false;
            let timestamp = parseInt(new Date().getTime()/1000);
            localStorage.setItem("jdb-notice-timestamp",timestamp);
        },
        openJdb: function() {
            let _that = this;
            _that.setDevJdbStatus([true,function() {
                _that.$store.state.user.jdbStatus = "on";
                _that.$store.state.alertToast.type = "success";
                _that.$store.state.alertToast.text = "开启节点小宝成功";
                _that.onClose();
            }])
        }
    },
    mounted: function() {
        let _that = this;
        let timestamp = new Date().getTime()/1000;
        let lastTimestamp = localStorage.getItem("jdb-notice-timestamp");
        lastTimestamp = lastTimestamp?parseInt(lastTimestamp):0;
        if(timestamp - lastTimestamp < (24*60*60)) {
            _that.$store.state.isShowJdbNotice = false;
        }
    }
}
</script>

<style lang="less" scoped>
.jdb_notice {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	z-index: 8;
	background-color: rgba(55, 55, 55, 0.8);
	.jdb_notice_wrap {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 260px;
		margin-left: -130px;
		margin-top: -60px;
		background-color: #eff8ff;
		padding-top: 1px;
		border-radius: 10px;
		text-align: center;

		.close_btn {
			position: absolute;
			right: 0px;
			top: -35px;
			width: 20px;
			height: 20px;
			background-image: url(../assets/jdb_notice_close.png);
		}
		.close_btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}

		.jdb_notice_icon {
			width: 140px;
			height: 140px;
			background-image: url(../assets/jdb_notice_icon.png);
			position: absolute;
			top: -70px;
			left: 50%;
			margin-left: -70px;
			background-position: center center;
			background-size: 100% 100%;
			background-repeat: no-repeat;
		}
		.jdb_notice_title {
			margin-top: 50px;
			color: #333333;
			font-size: 15px;
			text-align: center;
			margin-bottom: 10px;
		}
		.jdb_notice_select_wrap {
			.jdb_notice_select {
				display: inline-block;
				color: #999999;
				font-size: 11px;
				text-align: center;
			}
		}

		.open_btn {
			width: 100px;
			height: 30px;
			line-height: 30px;
			background-image: linear-gradient(to right, #5a6ef4, #2554c3);
			text-align: center;
			color: #ffffff;
			font-size: 13px;
			border-radius: 15px;
			margin: 15px auto 20px auto;
		}
		.open_btn:hover {
			cursor: pointer;
			opacity: 0.9;
		}
	}
}
</style>